import {createSmartAction} from 'redux-smart-actions';
import {push} from 'connected-react-router';
import {clearOrderRequestKey} from './orderKey';

export const getGifts = createSmartAction(() => ({
  request: {
    url: '/wp/v2/cadeaux?meta_key=cadeaux_points&order=asc&per_page=20',
  },
}));

export const getPointsHistory = createSmartAction(() => ({
  request: {
    url: '/mco-leclub-api/v1/points',
  },
}));

export const getMorePoints = createSmartAction(() => ({
  request: {
    url: '/wp/v2/actions?per_page=20',
  },
}));

// Preuve de visibilité de la marque Carte d'Or : photo de la carte dessert et commentaire facultatif.
export const postVisibilityProof = createSmartAction(({photo, comment} = {}) => {
  const data = new FormData();
  data.append('photo', photo);
  if (comment) data.append('comment', comment);

  return {
    request: {
      url: '/mco-leclub-api/v1/visibility',
      method: 'post',
      headers: {'Content-Type': 'multipart/form-data'},
      data,
    },
  };
});

export const postGiftOrder = createSmartAction(
  ({giftId, shippingAddress, variationRef, idempotencyKey} = {}) => ({
    request: {
      url: process.env.REACT_APP_GIFT_ORDER_ENDPOINT || '/mco-leclub-api/v1/gifts/order',
      method: 'post',
      headers: {'Idempotency-Key': idempotencyKey},
      data: {
        gift_id: giftId,
        variation_ref: variationRef,
        shipping_address: shippingAddress,
      },
    },
    meta: {
      onSuccess: (response, requestAction, {dispatch}) => {
        if (response.data?.success !== true || !response.data?.order_id) {
          throw new Error('Order confirmation missing');
        }
        clearOrderRequestKey(giftId);
        dispatch(
          push({
            pathname: `/gifts/order/${giftId}/confirmation`,
            state: {orderSubmitted: true, remainingPoints: response.data.remaining_points},
          }),
        );
        return response;
      },
    },
  }),
);
